import { MdCheck, MdDoneAll } from 'react-icons/md'
import { InternalMessageStatus } from '@/lib/api/internal-chat/internal-chat-api'

interface MessageStatusProps {
    status: InternalMessageStatus
    readCount?: number
    totalRecipients?: number
    isOwnMessage: boolean
}

export default function MessageStatus({
    status,
    readCount,
    totalRecipients,
    isOwnMessage,
}: MessageStatusProps) {
    if (!isOwnMessage) return null

    const getStatusIcon = () => {
        switch (status) {
            case 'SENT':
                return <MdCheck className="text-base-content/50" />
            case 'DELIVERED':
                return <MdDoneAll className="text-base-content/50" />
            case 'PARTIALLY_READ':
                return (
                    <div
                        className="tooltip tooltip-left"
                        data-tip={`Visto por ${readCount || 0} de ${totalRecipients || 0}`}
                    >
                        <MdDoneAll className="text-base-content/50" />
                    </div>
                )
            case 'READ':
                return <MdDoneAll className="text-secondary" />
            default:
                return <MdCheck className="text-base-content/50" />
        }
    }

    return <span className="text-sm ml-1">{getStatusIcon()}</span>
}
